import { 
    BaseScene,
} from './BaseScene';

import { HomeScene } from './HomeScene';
import { sceneManager } from '../SceneManager';
import {
    Text,
    Graphics,
} from 'pixi.js';

import {
    SCREEN_WIDTH,
    SCREEN_HEIGHT,
    FONT_1,
} from '../GameConst';
import { WalletConnectButton } from '../components/WalletConnectButton';
import { getAPI } from '../utils/API';
import { USER_DATA_EVENTS, userDataManager } from '../utils/UserDataManager';

export class TitleScene extends BaseScene {
    resources(){
        return [
        ];
    }
    async Init(){
        const background = new Graphics();
        background.beginFill(0x3b5a88);
        background.drawRect(0, 0, SCREEN_WIDTH, SCREEN_HEIGHT);
        background.endFill();
        this.addChild(background);
        const titleText = new Text('Title', {
            fontFamily: FONT_1,
            fontSize: 200,
            fill: 'white',
        });
        titleText.anchor.set(0.5);
        titleText.y = SCREEN_HEIGHT * 0.5;
        titleText.x = SCREEN_WIDTH * 0.5;
        this.addChild(titleText);

        const userData = await getAPI('/users');
        if(userData){
            userDataManager.updateUserData(userData);
            background.eventMode = 'static';
            background.once('pointerup', () => {
                sceneManager.LoadScene(HomeScene);
            });
        }else{
            // ログイン処理
            const walletConnectButton = new WalletConnectButton();
            walletConnectButton.x = SCREEN_WIDTH * 0.5;
            walletConnectButton.y = SCREEN_HEIGHT * 0.8;
            this.addChild(walletConnectButton);
            userDataManager.event.once(USER_DATA_EVENTS.LOGIN, () => {
                sceneManager.LoadScene(HomeScene);
            });
        }
    }
    UpdateScene(){
    }
}
